import React, { useState } from "react";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.phone ||
      !formData.subject ||
      !formData.message
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please fill in all fields before submitting.",
      });
      return;
    }
    try {
      // const res = await fetch("http://localhost:3001/api/enquiry", {
       const res = await fetch("https://fabgoldadmin.vercel.app/api/enquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: "Thank you for reaching out. We will get back to you soon.",
        });
      } else {
        Swal.fire("Error", "Something went wrong. Try again later.", "error");
      }

      console.log("Form Data Submitted:", formData);
      const phoneNumber = "7012065100";
      const message = `Hello! You have a new inquiry:\n\nName: ${
        formData.firstName + " " + formData.lastName
      }\nEmail: ${formData.email}\nPhone: ${formData.phone}\nSubject: ${
        formData.subject
      }\nMessage: ${formData.message}`;
      const encodedMessage = encodeURIComponent(message);
      const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

      window.open(whatsappURL, "_blank");

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    } catch {
      Swal.fire("Error", "Server is unreachable.", "error");
    }
  };

  return (
    <>
      <div
        id="holder"
        className="md:pl-[115px] max-sm:pl-[22px] mb-[44px] md:w-[82%] p-5"
      >
        <h3 className="text-[20px] leading-[30px] mb-[28px] text-tertary2 font-bold tracking-[3px] uppercase">
          LEAVE A MESSGE
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="flex md:flex-row max-sm:flex-col md:mb-[40px] md:gap-[5.5rem] max-sm:gap-[37px] ">
            <input
              type="text"
              className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-yellow-500 focus:ring-yellow-500 block w-full rounded-md sm:text-sm focus:ring-1"
              placeholder="First name"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
            />

            <input
              type="text"
              className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-yellow-500 focus:ring-yellow-500 block w-full rounded-md sm:text-sm focus:ring-1"
              placeholder="Last name"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
            />
          </div>

          <div class="mb-[40px]">
            <input
              type="email"
              className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-yellow-500 focus:ring-yellow-500 block w-full rounded-md sm:text-sm focus:ring-1"
              placeholder="Email Address"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div class="mb-[40px]">
            <input
              type="tel"
              className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-yellow-500 focus:ring-yellow-500 block w-full rounded-md sm:text-sm focus:ring-1"
              placeholder="Phone Number"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div class="mb-[40px]">
            <input
              type="text"
              className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-yellow-500 focus:ring-yellow-500 block w-full rounded-md sm:text-sm focus:ring-1"
              placeholder="Subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
            />
          </div>
          <div class="mb-[40px]">
            <textarea
              type="text"
              className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-yellow-500 focus:ring-yellow-500 block w-full rounded-md sm:text-sm focus:ring-1"
              placeholder="Your Message ..."
              name="message"
              value={formData.message}
              onChange={handleChange}
            />
          </div>
          <button
            className="w-[196px] uppercase border-none bg-none float-right font-[17px] leading-[19px] pl-[25px] pr[34px] py-[11px] mr-2 bg-tertary2 text-secondary1 mb-8 border rounded-md"
            type="submit"
          >
            send messge
          </button>
        </form>
      </div>
    </>
  );
};

export default ContactForm;
